import { Component } from '@angular/core';
import SlotService from '../../cart-process/slot.service';
import { AccessorySecondPageModel } from '../../models/accessory-second-page.model';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { combineLatest } from 'rxjs';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Component({
  selector: 'boho-side-order-details-accessory',
  templateUrl: './boho-side-order-details-accessory.component.html',
})
export class BohoSideOrderDetailsAccessoryComponent {
  public showSection: boolean = false;
  public accessorySlot: Array<AccessorySecondPageModel> = [];
  public currencySymbol: string = 'zł';

  constructor(
    private slotService: SlotService,
    private notificationProvider: NotificationProviderService,
    private commonInfo: CommonInfoService
  ) {

    combineLatest(
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.SLOTS_SERVICE),
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.COMMON_INFO)
    ).subscribe( (_context: any) => {

      const [_slotService, _commonInfo]: any = _context;

      if (!_slotService || !_commonInfo) {
        return;
      }

      const list: any = _slotService.accessories;

      this.showSection = !!list.length;
      this.accessorySlot = list;

    });
  }

}
